<div class="row form-row">
  <div class="col-12 mt-2">
    <div class="form-group text-start">
      <label for="currentField">{{label() + '.' + fieldName() | translate}}
        <span *ngIf="isRequired()" class="required">*</span>:
      </label>
      <div class="input-group">
        <ng-container *ngIf="typeInput() === 'password'; else regularInput">
          <div class="input-with-toggle w-100">
            <input [type]="showPassword ? 'text' : 'password'" (input)="onInputChange($event)" class="form-control" name="currentField" id="currentField" [maxLength]="maxLength()"
              [disabled]="isDisabled()"
              (blur)="onBlur()"
              [value]="currentValue"
              [ngClass]="{ 'is-invalid': showError, 'select-disabled': isDisabled()}"
              [required]="isRequired()">
            <button type="button" class="password-toggle" (click)="showPassword = !showPassword" tabindex="-1">
              <i class="bi text-white" [ngClass]="showPassword ? 'bi-eye-slash' : 'bi-eye'"></i>
            </button>
          </div>
        </ng-container>
        <ng-template #regularInput>
          <input [type]="typeInput()" (input)="onInputChange($event)" class="form-control" name="currentField" id="currentField" [maxLength]="maxLength()"
            [disabled]="isDisabled()"
            (blur)="onBlur()"
            [value]="currentValue"
            [ngClass]="{ 'is-invalid': showError, 'select-disabled': isDisabled()}"
            [required]="isRequired()">
        </ng-template>
        <div *ngIf="showError" class="invalid-feedback d-block mt-2">
          <div *ngIf="isRequired()">
            {{ ('errors.' + labelError + 'Required') | translate }}
          </div>
          <div *ngIf="hasMinLength()">
            {{ ('errors.' + labelError + 'MinLength') | translate }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
